
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookie_policy",
      function () {
        return require("private-next-pages/cookie_policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookie_policy"])
      });
    }
  